import { get } from 'lodash';
import type { IWixCodeApi } from '../controller/wix-code-api';

const isProduction = process.env.NODE_ENV === 'production';

const getIsDebug = (wixCodeApi: IWixCodeApi) => {
  const { debug, ssrDebug } = get(
    wixCodeApi,
    'location.query',
    {} as Record<string, string>,
  );

  return (!!debug && debug !== 'false') || (!!ssrDebug && ssrDebug !== 'false');
};

export default function getEnvironment(wixCodeApi: IWixCodeApi) {
  const isEditor = wixCodeApi.window.viewMode === 'Editor';
  const isPreview = wixCodeApi.window.viewMode === 'Preview';

  return {
    isEditor,
    isPreview,
    isEditorSegment: isEditor || isPreview,
    isSite: wixCodeApi.window.viewMode === 'Site',
    isSSR: wixCodeApi.window.rendering.env === 'backend',
    isDebug: getIsDebug(wixCodeApi),
    isProduction,
  };
}
